module.exports = __webpack_public_path__ + "static/media/xray-training-medial-nonflex1.c997bdc3.png";